import { QUICK_FEEDBACK_SENTIMENTS } from 'admin-panel/constants/dashboard';
import { hotelUtcOffset } from 'admin-panel/utils/hotel-time';
import type { QuickFeedbackMessage } from 'admin-panel/services/dashboard-analytics';
import type { QuickFeedbackSentiment } from 'admin-panel/types/dashboard';

const COLUMNS = [
  { key: 'timestamp', width: 23 },
  { key: 'room', width: 16 },
  { key: 'sentiment', width: 18 },
  { key: 'message', width: 80 },
] as const;

export function quickFeedbackExportSheet(
  messages: QuickFeedbackMessage[],
  timeZone: string,
  translate: (key: string) => string
) {
  const prefix = 'panels.dashboard.quick-feedback';
  const headers = COLUMNS.map(({ key }) => ({
    type: String,
    value: translate(`${prefix}.export-columns.${key}`),
    fontWeight: 'bold' as const,
  }));
  const sentiments = Object.fromEntries(
    QUICK_FEEDBACK_SENTIMENTS.map((sentiment) => [
      sentiment,
      translate(`${prefix}.sentiments.${sentiment}`),
    ])
  ) as Record<QuickFeedbackSentiment, string>;

  const rows = messages
    .map((message) => ({ message, instant: Date.parse(message.createdAt) }))
    .sort((a, b) => b.instant - a.instant)
    .map(({ message, instant }) => {
      const cells = {
        timestamp: {
          type: Date,
          // Excel stores the hotel's wall-clock time without a timezone.
          value: new Date(instant + hotelUtcOffset(instant, timeZone)),
          format: 'yyyy-mm-dd hh:mm:ss',
        },
        room: { type: String, value: message.roomCode ?? '' },
        sentiment: { type: String, value: sentiments[message.satisfaction] },
        message: { type: String, value: message.message ?? '' },
      };
      return COLUMNS.map(({ key }) => cells[key]);
    });

  return {
    data: [headers, ...rows],
    columns: COLUMNS.map(({ width }) => ({ width })),
  };
}
